import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import '../assets/css/style.css';
import Header from './Header';
import itemImg from '../assets/images/closed-collection-details/item-image.png';

class ClosedCollectionDetails extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Item details area start */}
                <div className="container mb-5">
                    <div className="row collection justify-content-between">
                        <div className="col-md-6 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <p><Link to="#">VIEW COLLECTION</Link>
                                <small className="pull-right">Contract Address</small>
                            </p>
                            <small className="pull-right">0xbfb69918f12eed843c67058b2ee9059f1440133e</small>
                        </div>

                        <div className="col-md-5 upcoming mb-4 mt-auto closed-collection-text">
                            <h3>Duke Dumont</h3>
                            <h1>Amethyst
                                <span>
                                    $499.00
                                </span>
                            </h1>
                            <hr />
                            <p>DREAM LOGIC Open Editions
                                <span>Edition of 9</span>
                            </p>
                            <p>Amethyst cloud , in a polar simulation, pierced by matter.</p>
                            {/* Temp area start */}
                            <p className="space"></p>
                            {/* Temp area end */}
                            <button disabled>CLosed</button>
                            <h6><Link to="#">View listings in marketplace</Link></h6>
                        </div>
                    </div>
                </div>
                {/* Item details area end */}
            </div>
        )
    }
};

export default ClosedCollectionDetails;